import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import Editor from "../components/add-new-post/Editor";
import SidebarActions from "../components/add-new-post/SidebarActions";
import SidebarCategories from "../components/add-new-post/SidebarCategories";
import useMedia from "../modules/media/hooks";
import { BASE_URL } from "../modules/host";
import { post } from "axios";

const AddNewPost = ({ location, history }) => {
  const a = require("../images/sampleImage.png");

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(a);
  const [press, setPress] = useState("useB press");
  const [date, setDate] = useState(new Date());
  const [regDate, setRegDate] = useState(new Date());
  const { fetchByKeyword, deleteItem, fetchAllMedias } = useMedia();
  const [imageLoading, setImageLoading] = useState(true);
  const [id, setId] = useState(-1);
  const [loading, setLoading] = useState(false);
  console.log(location.state)

  const time = Date.now(); //img cashing

  useEffect(() => {
    if (location.state) {
      setLoading(true)
      const data = fetchByKeyword(location.state);
      data.then(data => {
        console.log(data[0]);
        let image;
        try {
          image = `/uploads/media/${data[0].img_id}?v=${time}`;
          console.log(`image get success ${image}`)
        } catch (error) {
          image = a;
          console.log(`image get error ${image}`)
        }

        setImage(image);
        setImageLoading(false);
        setContent(data[0].content);
        setPress(data[0].source);
        setDate(data[0].date);
        setTitle(data[0].title);
        setId(data[0].id);
        console.log(id);
        setLoading(false)
      });
    }
  }, []);

  const makeForm = () => {
    const formData = new FormData();
    if (id !== -1) {
      formData.append("id", id);
      formData.append("date", date);
    } else {
      formData.append(
        "date",
        `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      );
    }
    formData.append("title", title);
    formData.append("source", press);
    formData.append("img_id", image);
    formData.append("content", content);
    formData.append(
      "regdate",
      `${regDate.getFullYear()}-${regDate.getMonth() + 1}-${regDate.getDate()}`
    );
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return post(`${BASE_URL}news/add`, formData, config);
  };
  const onSubmit = e => {
    e.preventDefault();
    makeForm().then(res => {
      window.alert("성공적으로 게재되었습니다.");
      console.log(res.data);
      history.push("/medias");
      fetchAllMedias();
    });
  };

  if (loading) {
    return (<Container fluid className="main-content-container px-4 pb-4" style={{
      display: "flex",
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      로딩중입니다.
      <i className="material-icons" style={{ fontSize: 50, marginLeft: 10 }}>cached</i>
    </Container>)
  }

  return (

    <Container fluid className="main-content-container px-4 pb-4">
      <Form
        onSubmit={e => {
          e.preventDefault();
          console.log(e);
        }}
        action={`${BASE_URL}news/add`}
        method="post"
      >
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="작성하기"

            className="text-sm-left"
          />
        </Row>

        <Row>
          {/* Editor */}
          <Col lg="9" md="12">
            <Editor
              title={title}
              setTitle={setTitle}
              content={content}
              setContent={setContent}
            />
          </Col>

          {/* Sidebar Widgets */}
          <Col lg="3" md="12">
            <SidebarActions
              image={image}
              setImage={setImage}
              imageLoading={imageLoading}
              setImageLoading={setImageLoading}
            />
            <SidebarCategories
              press={press}
              setPress={setPress}
              date={date}
              setDate={setDate}
              regDate={regDate}
              setRegDate={setRegDate}
            />
            <Button
              size="lg"
              theme="primary"
              className="col-md-12"
              type="submit"
              onClick={onSubmit}
            >
              저장
            </Button>
            {id > 0 && <Button
              size="lg"
              id="close"
              theme="danger"
              style={{
                width: "100%",
                marginTop: 10
              }}
              classname="col-md-12 w-100"
              onClick={() => {
                window.confirm("정말 삭제하시겠습니까?") && deleteItem(id).then(
                  history.push("/medias"),
                );
              }}
            >
              삭제
            </Button>}
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

// const AddNewPost = () => (
// );

export default AddNewPost;
